export default __webpack_public_path__ + "static/media/TheCodex.47f3862f.jpg";